<div class="variant-card-header grid-container m-12:b">
    <div
        class="g-4 variant-icon lg:hide"
        [ngStyle]="{ 'background-image': 'url(' + iconPath + ')' }"
    >
        <span class="p md:hide nowrap"
            ><button
                name="button"
                [attr.aria-description]="fullTitle + ' Details'"
                [attr.aria-expanded]="showBody"
                [attr.aria-controls]="bodyId"
                class="details-button lg:hide c:blue-700"
                [ngClass]="{ '-open': showBody }"
                (click)="showBody = !showBody"
                type="button"
            >
                Details
            </button>
        </span>
    </div>
    <div class="g-auto lg:g-12 align:c flex-grow">
        <span class="h2 fw:light m-0:b variant-title">{{ title }}</span>
        <span class="variant-price">
            @if (showPriceFrom) {
                <span class="price-from m-6:r">ab</span>
            }
            <app-display-price [price]="price"></app-display-price
        ></span>
        <span class="h4 variant-hint m-0:b">{{ settlementPeriod === 'year' ? 'Jährlich' : 'Monatlich' }}</span>
    </div>
</div>
<div
    class="variant-card-body grid-container"
    [ngClass]="{ '-toggle-hide': !showBody }"
>
    <hr class="g-12" />
    <div
        class="variant-icon g-12 m-12:b hide lg:show"
        [ngStyle]="{ 'background-image': 'url(' + iconPath + ')' }"
    ></div>
    <div
        class="g-12"
        [id]="bodyId"
    >
        <ng-content></ng-content>
    </div>
</div>
<div class="variant-buttons">
    <a
        class="button m-12:t"
        [routerLink]="['/', 'produkte', productSlug, 'first']"
        [attr.aria-description]="fullTitle + ' abschließen'"
        >abschließen</a
    >
    <a
        class="button -ghost -dark fs:xs info-button m-12:t"
        [routerLink]="['/', 'produkte', productSlug, 'landing']"
        [attr.aria-description]="'Weitere Infos zur ' + fullTitle"
        >Weitere Infos</a
    >
</div>
